import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { CIPXVerticalDrawerComponent } from './vertical-drawer-component';
import { CIPXDrawerTemplateComponent } from './drawer-template.component';

@Component({
  selector: 'cipx-default-drawer',
  template: `
    <cipx-drawer-template
      #drawerTemplate
      [fixed]="fixed"
      [sizeType]="sizeType"
      [showUpBand]="showUpBand"
      [mode]="mode"
      [name]="name"
      [opened]="opened"
      [position]="position"
      [transparentOverlay]="transparentOverlay"
      [disableOverlay]="disableOverlay"
      [disableOverlayClose]="disableOverlayClose"
      [showCloseButton]="showCloseButton"
      [title]="title"
      [showHeader]="showHeader"
      [showBackButton]="showBackButton"
      (openedChanged)="onOpenedChanged($event)"
      (closeClick)="onCloseClick()"
      (backClick)="onBackClick()"
      (viewInitialized)="onTemplateViewInit()">
      <!-- Pass through any ng-content -->
      <ng-content></ng-content>
    </cipx-drawer-template>
  `,
  styleUrls: ['./drawer.component.scss'],
  imports: [
    CommonModule,
    FuseDrawerModule,
    CIPXDrawerTemplateComponent
  ],
  standalone: true,
})
export class CIPXDefaultDrawerComponent extends CIPXVerticalDrawerComponent {
  // This component uses the same template component as CIPXDrawerComponent
  // Both components share the exact same drawer structure without duplication
}
